import {Breadcrumbs} from '@primer/react-brand/esm'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {
  BreadcrumbSeoSchema,
  type BreadcrumbListItem,
} from '@github-ui/swp-core/components/structuredData/BreadcrumbSeoSchema'

type BreadcrumbProps = {
  items: BreadcrumbListItem[]
  selectLastItem?: boolean
}

export const BreadcrumbsList = ({items, selectLastItem = false}: BreadcrumbProps) => {
  return (
    <>
      <Breadcrumbs>
        {items.map(({name, url}, index) => {
          return (
            <Breadcrumbs.Item
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={`${name}-${index}`}
              href={url}
              {...getAnalyticsEvent({
                action: name,
                tag: 'link',
                context: 'breadcrumb',
                location: 'header',
              })}
              data-ref={`article-breadcrumb-link-${name}`}
              {...(selectLastItem && index === items.length - 1 && {selected: true})}
            >
              {name}
            </Breadcrumbs.Item>
          )
        })}
      </Breadcrumbs>
      <BreadcrumbSeoSchema items={items} />
    </>
  )
}
